import { ApiData } from 'states/types'
import { NivosFolder } from 'types/nivos-folder'

const Types = {
  SET: '@@document-admin/SET',
  ADD: '@@document-admin/ADD',
  UPDATE: '@@document-admin/UPDATE',
  LOADING: '@@document-admin/LOADING',
  DELETE: '@@document-admin/DELETE'
}

export type Payload = ApiData<NivosFolder>

export { Types }
